import { createFileRoute } from "@tanstack/react-router";
import { listBlogArticles } from "../lib/blog.functions";
import { BlogIndexPage } from "../components/blog-index";
import { getLocale, blogIndexAltLinks } from "../lib/blog-locales";

const SITE = "https://capitalpropressurewashing.com";
const LOCALE = getLocale("es");
const TITLE = `${LOCALE.ui.blogTitle} | Capital Pro Pressure Washing`;
const DESC = LOCALE.ui.blogIntro;

export const Route = createFileRoute("/es/blog")({
  loader: async () => ({
    articles: await listBlogArticles({ data: { language: "es" } }),
  }),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE}/es/blog` },
      { property: "og:locale", content: LOCALE.ogLocale },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [
      { rel: "canonical", href: `${SITE}/es/blog` },
      ...blogIndexAltLinks(SITE),
    ],
  }),
  component: BlogIndexEs,
  errorComponent: () => (
    <main className="mx-auto max-w-[1200px] px-4 py-12">
      <p className="text-[var(--brand-charcoal)]/70">{LOCALE.ui.loadError}</p>
    </main>
  ),
  notFoundComponent: () => (
    <main className="mx-auto max-w-[1200px] px-4 py-12">
      <p className="text-[var(--brand-charcoal)]/70">{LOCALE.ui.noArticles}</p>
    </main>
  ),
});

function BlogIndexEs() {
  const { articles } = Route.useLoaderData();
  return <BlogIndexPage articles={articles} locale={LOCALE} />;
}
